import { css } from '@emotion/react';

const isCocoSharp = (name: string): boolean =>
  name.startsWith('body-') || name.startsWith('label-');

export const font = (name: string) => css`
  font: var(--font-${name});
  font-variation-settings: var(--coco-sharp-variation-settings);
  font-feature-settings: 'ss04' ${isCocoSharp(name) ? 'on' : 'off'};
`;
